/**
 * Procedure Categories and Procedures for DM in Pediatric Nephrology students
 * Extracted with strict evidence from official NMC PDF (Page 5, 25-27: "Competency in Procedural/Practical Skills")
 */
export const PEDIATRIC_NEPHROLOGY_PROCEDURES = {
  "Pediatric Renal Biopsy, Vascular Access & Catheter Procedures": [
    "Percutaneous Renal Biopsy (Native and Transplanted Kidneys)",
    "Temporary Central Venous Vascular Access Placement for Hemodialysis / RRT",
    "Acute Peritoneal Dialysis Catheter Insertion",
  ],
  "Pediatric Dialysis, Apheresis & Bedside Renal Procedures": [
    "Prescribing, Conducting & Supervising Hemodialysis (Acute & Chronic)",
    "Prescribing, Conducting & Supervising Peritoneal Dialysis & Peritoneal Equilibration Test (PET)",
    "Prescribing, Conducting & Supervising Continuous Renal Replacement Therapy (CRRT)",
    "Prescribing, Conducting & Supervising Slow Low Efficiency Daily Dialysis (SLED)",
    "Prescribing, Conducting & Supervising Therapeutic Plasmapheresis / Plasma Exchange",
    "Bedside Urinalysis & Phase Contrast Microscopy for Dysmorphic RBCs & Casts",
  ],
};

export const PEDIATRIC_NEPHROLOGY_CATEGORIES = Object.keys(PEDIATRIC_NEPHROLOGY_PROCEDURES);

export const isDMInPediatricNephrologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("pediatric nephrology") ||
    d.includes("paediatric nephrology")
  );
};
